/* When we dynamically change the inline styles of the elements,
and those styles contain URL declarations eg. "background-images: url('/path/to/img')",
Safari additionally prefixes those URLs with the `window.location.origin`.
So, each URL starts being the absolute one.

That's an issue for us, cause because of that browser tries to fetch assets from a wrong place.
In order to bypass that bug, we need to manually strip editor origin from the serialized version
of the page. */

const originRegexp = new RegExp(window.location.origin, 'gi');
const removeOriginFromHTMLString = (htmlString) => htmlString.replace(originRegexp, '');
export default removeOriginFromHTMLString;
